import { render, staticRenderFns } from "./Patientlist.vue?vue&type=template&id=b667d786"
import script from "./Patientlist.vue?vue&type=script&lang=js"
export * from "./Patientlist.vue?vue&type=script&lang=js"
import style0 from "./Patientlist.vue?vue&type=style&index=0&id=b667d786&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports